import { Typography } from "@mui/material";
import type { FC } from "react";
import type { ParticipantListResponse, ParticipantListTemplateResponse } from "./participantListApi";
import ParticipantListEditForm from "./ParticipantListEditForm";
import ParticipantListReadonlyPanel from "./ParticipantListReadonlyPanel";
import type { UseParticipantListEditorResult } from "./useParticipantListEditor";

interface Props {
  readonly noParticipantsRequired: boolean;
  readonly showEditor: boolean;
  readonly template: ParticipantListTemplateResponse | undefined;
  readonly lastSavedList: ParticipantListResponse | undefined;
  readonly editor: UseParticipantListEditorResult;
  readonly selectedList: ParticipantListResponse | undefined;
  readonly previousList: ParticipantListResponse | undefined;
  readonly showDiffs: boolean;
}

const ParticipantListMainContent: FC<Props> = ({
  noParticipantsRequired,
  showEditor,
  template,
  lastSavedList,
  editor,
  selectedList,
  previousList,
  showDiffs,
}) => {
  if (noParticipantsRequired) {
    return (
      <Typography variant="subtitle1">Lista uczestników nie jest wymagana dla produktów w tym zamówieniu</Typography>
    );
  }

  if (showEditor && template) {
    return <ParticipantListEditForm template={template} previousParticipantList={lastSavedList} editor={editor} />;
  }

  if (!selectedList) {
    return null;
  }

  return (
    <ParticipantListReadonlyPanel
      participantList={selectedList}
      previousParticipantList={previousList}
      requiredFields={template?.requiredFields}
      showDiffs={showDiffs}
    />
  );
};

export default ParticipantListMainContent;
